module.exports = __webpack_public_path__ + "media/svg/location-81b274b7.svg";